'use client';

import { twMerge } from 'tailwind-merge';
import { QuoteCard } from '../../../../components/Cards/QuoteCard/QuoteCard';
import { ContinuousCarousel } from '../../../../components/Carousels/ContinuousCarousel/ContinuousCarousel';
import { GetSingleSpecies_entry_speciesTips_edges_node } from '../../../../interfaces/graphql';
import { SUB_LINK_IDS } from '../../helpers/speciesHelpers';
import { Container } from '../../../../components/Container/Container';

interface IProps {
  className?: string;
  tipsList: GetSingleSpecies_entry_speciesTips_edges_node[];
}

export const TipsSection = ({ className, tipsList }: IProps) => {
  return (
    <Container
      id={SUB_LINK_IDS.PRO_TIPS}
      className={twMerge(
        'w-full scroll-mt-(--navigation-scrolltop-offset-mobile) px-6 sm:scroll-mt-(--navigation-scrolltop-offset)',
        className,
      )}
    >
      <ContinuousCarousel dataTestId="species-tips" title="Tips from our Pro anglers">
        {tipsList.map(({ tip, userDisplayName, externalId, user, userDescription }) => (
          <QuoteCard
            key={`water-reviews-${externalId}`}
            bodyText={tip}
            username={userDisplayName}
            userImageUrl={user.avatar?.url}
            userDescription={userDescription}
          />
        ))}
      </ContinuousCarousel>
    </Container>
  );
};
